import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';
import { GetProfileDetailsDto } from '../../../dto/getprofile/getprofiledetailsdto';

export interface GetProfileDetailsResponse extends APIResponse
{
    getProfileDetailsDto(): GetProfileDetailsDto;
}

export class GetProfileDetailsResponseDtoImpl extends APIResponseDtoImpl implements GetProfileDetailsResponse
{
    private getProfileDto : GetProfileDetailsDto;

    getProfileDetailsDto(): GetProfileDetailsDto
    {
        return this.getProfileDto;
    }
    setProfileDetailsDto(getProfileDto: GetProfileDetailsDto)
    {
        this.getProfileDto = getProfileDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/getprofiledetails/getprofiledetailsresponse.tsx